import React from 'react';
import { Localizer } from 'services/Localizer';
import Spinner from 'shared/components/Spinner';
import InlineAlert from 'shared/edit/InlineAlert';
import { TextBoxField } from 'shared/edit/fields';
import { useAxiosFormSubmitter } from 'shared/hooks/useBaseAxiosFormSubmitter';
import RocForm from 'shared/edit/RocForm';
import { ServerData } from 'services/ServerData';

interface ForgotPasswordValues {
	email: string;
}

export default function ForgotPassword() {
	const forgotPasswordSubmitter = useAxiosFormSubmitter<ForgotPasswordValues>(
		{
			url: '/ajax/user/forgot-password',
		},
		'ForgotPassword',
	);

	if (forgotPasswordSubmitter.submitted) {
		return (
			<>
				<h1>{Localizer('ForgotPasswordConfirmationPageTitle')}</h1>
				<p>{Localizer('ForgotPasswordConfirmation')}</p>
			</>
		);
	} else {
		return (
			<>
				<h1>{Localizer('ForgotPasswordPageTitle')}</h1>
				<RocForm<ForgotPasswordValues>
					onSubmit={forgotPasswordSubmitter.handleSubmit}
					render={({ handleSubmit, submitError, submitting }) => {
						return (
							<form className="roc-form roc-forgot-password-form" onSubmit={handleSubmit}>
								{submitError ? (
									<InlineAlert
										title={Localizer('ErrorMessageGenericTitle')}
										message={submitError}
										error={null}
									/>
								) : null}

								<TextBoxField
									isRequired
									label={
										ServerData.USE_EMAIL_AS_USERNAME ? Localizer('Email') : Localizer('Username')
									}
									name={ServerData.USE_EMAIL_AS_USERNAME ? 'email' : 'userName'}
									placeholder={
										ServerData.USE_EMAIL_AS_USERNAME ? Localizer('Email') : Localizer('Username')
									}
								/>

								<button
									disabled={submitting}
									type="submit"
									color="secondary"
									className="roc-btn"
									data-testid="submit-forgot-password"
								>
									{Localizer('Submit')} {submitting ? <Spinner light /> : null}
								</button>
							</form>
						);
					}}
				/>
			</>
		);
	}
}
